var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-my_redemptions"}},[(_vm.loading)?_c('Loading'):_c('MyRedemptions',{attrs:{"customItems":_vm.customItemsMyRedemptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }